import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function unwrapArrayPayload(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.$values)) return data.$values;
  return [];
}

const FBIntegrationService = {
  getAllFBIntegrations: async () => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetAllFacebookClientConfigs`);
      return unwrapArrayPayload(response.data);
    } catch (error) { 
      console.error('Error fetching FBIntegartions:', error);
      throw error;
    }
  },

  getFBIntegrationById: async (id) => { 
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigById/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching FBIntegartions with ID ${id}:`, error);
      throw error;
    } 
  },


  createFbIntegration: async (fbintegrationdata) => {
    try {
      const response = await axios.post(`${API_URL}/FacebookClientConfig/CreateFacebookClientConfig/`, fbintegrationdata);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateFBIntegration: async (id, payload) => {
    try {
      const body = payload && typeof payload.get === 'function'
        ? Object.fromEntries(payload.entries())
        : payload;
      const response = await axios.put(
        `${API_URL}/FacebookClientConfig/UpdateFacebookClientConfig/${id}`,
        { ...body, id: Number(id) }
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating FBIntegartion with ID ${id}:`, error);
      throw error;
    }
  },

  deleteFBIntegration: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/FacebookClientConfig/DeleteFacebookClientConfig/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting FBIntegartion with ID ${id}:`, error); 
      throw error;
    }
  },
  getFBIntegrationsByClientId: async (clientId) => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigByClientId/${clientId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching FBIntegartion with ID ${clientId}:`, error);
      throw error;
    }
  }, 

  getFBIntegrationsAsyncByClientId: async (clientId) => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigAsyncByClientId/${clientId}`);
      return unwrapArrayPayload(response.data);
    } catch (error) {
      console.error(`Error fetching FBIntegartion with ID ${clientId}:`, error);
      throw error;
    }
  },

  importFacebookLeads: async (clientId, userId) => {
    try {
      const response = await axios.post(`${API_URL}/ImportLead/ImportLeads/${clientId}/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error importing Facebook leads for client ${clientId}:`, error);
      throw error;
    }
  },

  importFacebookLeadsForConfig: async (clientId, configId, userId) => {
    try {
      const response = await axios.post(
        `${API_URL}/ImportLead/ImportLeads/${clientId}/${configId}/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error importing Facebook leads for config ${configId}:`, error);
      throw error;
    }
  },

  discoverLeadGenFormsPreview: async (pageId, accessToken) => {
    try {
      const response = await axios.post(`${API_URL}/FacebookClientConfig/DiscoverLeadGenFormsPreview`, {
        pageId,
        accessToken,
      });
      return unwrapArrayPayload(response.data);
    } catch (error) {
      console.error('Error discovering Lead Gen forms:', error);
      throw error;
    }
  },
};


export default FBIntegrationService;
